import * as React from 'react';

import { Col, cn } from '@rematter/ui-web';
import {
  LucideFile,
  LucideFileImage,
  LucideFileSpreadsheet,
  LucideFileText,
} from 'lucide-react';

export type FileIconProps = { fileName: string };

export const FileIcon = ({ fileName }: FileIconProps) => {
  const fileExtension = React.useMemo(
    () => fileName.split('.').pop()?.toLowerCase() ?? '',
    [fileName],
  );

  const isImage = React.useMemo(
    () =>
      [
        'jpeg',
        'jpg',
        'png',
        'gif',
        'svg',
        'webp',
        'heic',
        'heif',
        'avif',
        'tiff',
        'bmp',
      ].includes(fileExtension),
    [fileExtension],
  );
  const isDoc = React.useMemo(
    () => ['doc', 'docx'].includes(fileExtension),
    [fileExtension],
  );
  const isPdf = React.useMemo(
    () => ['pdf'].includes(fileExtension),
    [fileExtension],
  );

  const isSpreadsheet = React.useMemo(
    () => ['xls', 'xlsx', 'csv'].includes(fileExtension),
    [fileExtension],
  );

  return (
    <Col
      className={cn(
        '@FileIcon',
        cn(
          'rounded bg-neutral/50 p-2 text-white [&_svg]:size-6 [&_svg]:stroke-[1.5px]',
          isImage && 'bg-warning',
          isDoc && 'bg-primary',
          isPdf && 'bg-magenta',
          isSpreadsheet && 'bg-success',
        ),
      )}
    >
      {isImage && <LucideFileImage />}
      {(isDoc || isPdf) && <LucideFileText />}
      {isSpreadsheet && <LucideFileSpreadsheet />}
      {!isImage && !isDoc && !isPdf && !isSpreadsheet && <LucideFile />}
    </Col>
  );
};
